import Stack from '../../_components/Stack';
import type { EmptyStateProps } from './types';
import EmptyStateAsStep from './variants/EmptyStateAsStep';
import EmptyStateDefault from './variants/EmptyStateDefault';
import EmptyStateStatus from './variants/EmptyStateStatus';
import EmptyStateWithList from './variants/EmptyStateWithList';

const EmptyStateMap: Record<string, React.FC<EmptyStateProps>> = {
  default: EmptyStateDefault,
  list: EmptyStateWithList,
  step: EmptyStateAsStep,
  status: EmptyStateStatus,
};

function EmptyState(props: EmptyStateProps) {
  const { variant, className } = props;
  const EmptyStateComponent = EmptyStateMap[variant];

  return (
    <Stack className={className} direction="row" justifyContent="center">
      <EmptyStateComponent {...props} />
    </Stack>
  );
}

export default EmptyState;
